import { render, staticRenderFns } from "./examManager.vue?vue&type=template&id=652be4e9&scoped=true&"
import script from "./examManager.vue?vue&type=script&lang=js&"
export * from "./examManager.vue?vue&type=script&lang=js&"
import style0 from "./examManager.vue?vue&type=style&index=0&lang=css&"
import style1 from "./examManager.vue?vue&type=style&index=1&id=652be4e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652be4e9",
  null
  
)

export default component.exports